module.exports = __webpack_public_path__ + "static/sehwan_jeon-534a32d09bf9ea9524f4c70caacd58f2.jpg";